import { appConfig, headerConfig, refineHeader } from "../../config";
import auth from "../auth";
import { authHeader } from "../../_helpers/auth-header";

export const frontService = {
  getDealList,
  getMenuList,
  topDeals,
  currentDealList,
  upcomingDealList,
  dealDetail,
  addToCart,
  getCartDetail,
  updateCart,
  removeItem,
  checkout,
  applyPromoCode,
  register,
  userLogout,
  userVoucherList,
  userOrderList,
  customerDetail,
  profileUpdate,
  changePassword,
  printVoucher,
  categoryWiseDeal,
  storeCredit,
  generateCoupon,
  selectAttributes,
  subscribeUser,
  checkUserDeal,
  getSiteCity,
  affiliateWidget,
  becomePartner,
  partnerPermission,
  orderStatus,
  unsubscribeUser,
  getcharityList,
  removePromoCode,
  voucherStatus,
  getRefferals,
  delteCard
};

function getDealList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}deal-list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function getMenuList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}menu-list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function topDeals(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}top-deal`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function currentDealList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}current-deal-list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function upcomingDealList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}future-deal-list`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function addToCart(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}cart/addToCart`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function dealDetail(postData) {
  let url;
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };
  url = `${appConfig.api.url}deal`;
  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function affiliateWidget(permalink){
    refineHeader();
    const requestOptions = {
      method: "GET",
      headers: headerConfig.headerDatas,
      mode: "cors"
    };

    return fetch(`${appConfig.api.url}widget/${permalink}`, requestOptions)
      .then(handleResponse)
      .then(data => {
        return data.data;
    });
}

function getCartDetail(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}cart/deals`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function updateCart(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}cart/updateQuantityToCart`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function checkout(postData, url) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(
    `${appConfig.api.url}${url}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function applyPromoCode(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}cart/applyPromoCode`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function register(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}register`, requestOptions)
    .then(handleResponse)
    .then(data => {
      localStorage.setItem("user", JSON.stringify(data.result.token));
      localStorage.setItem("userTypeName", data.result.userTypeName);
      localStorage.setItem("user_id", data.result.user_id);
      localStorage.setItem("userTypeID", data.result.userTypeID);

      auth.setToken(data.result.token);
      const {
        status,
        firstName,
        lastName,
        userName,
        userTypeName,
        user_id,
        siteID,
        user_permissions
      } = data.result;
      const userdata = {
        status,
        firstName,
        lastName,
        userName,
        userTypeName,
        user_id,
        siteID,
        user_permissions
      };
      auth.setUserInfo(userdata);
      return data.data;
    });
}

function userVoucherList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}voucher/userVouchers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function userOrderList(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}voucher/user-offers`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function removeItem(cartID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}cart/delete/${cartID}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function userLogout() {
  // remove user from local storage to log user out
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}logout`, requestOptions)
    .then(handleResponse)
    .then(user => {
      auth.clearAllAppStorage();
      localStorage.removeItem("user");
      localStorage.removeItem("user_id");
      localStorage.removeItem("userTypeName");
      return user;
    });
}

function customerDetail(user_id) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}user/detail/${user_id}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function profileUpdate(data) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(data)
  };

  return fetch(`${appConfig.api.url}user/edit`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function changePassword(data) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(data)
  };

  return fetch(`${appConfig.api.url}user/change-password`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function printVoucher(voucherID, type, siteID) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(
    `${appConfig.api.url}voucher/userVoucher-detail/${voucherID}/${type}/${siteID}`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function categoryWiseDeal(data) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(data)
  };

  return fetch(
    `${appConfig.api.url}category-deals-front`,
    requestOptions
  )
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function storeCredit() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}store-credit/store-amount`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function generateCoupon(dealID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(dealID)
  };

  return fetch(`${appConfig.api.url}coupan/generate-coupan`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function getSiteCity(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}public-city/site-cities`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function selectAttributes(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}cart/selectAttributes`, requestOptions)
    .then(handleResponse)
    .then(category => {
      return category;
    });
}

function subscribeUser(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}subscribers/subscribe-user`, requestOptions)
    .then(handleResponse)
    .then(subscribe => {
      return subscribe;
    });
}

function checkUserDeal() {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}deal/check-user-deal`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function becomePartner(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}become-a-partner/merchant`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function partnerPermission(url) {
  refineHeader();
  const requestOptions = {
    method: "GET",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function orderStatus(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}voucher/check-order-status`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function unsubscribeUser(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}subscribers/manage-subscription`, requestOptions)
    .then(handleResponse)
    .then(subscribe => {
      return subscribe;
    });
}

function removePromoCode(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}cart/removePromoCode`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getcharityList() {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(`${appConfig.api.url}charity/charity`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data.data;
    });
}

function voucherStatus(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(postData)
  };

  return fetch(`${appConfig.api.url}voucher/redeem`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function delteCard(formData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    body: JSON.stringify(formData)
  };

  return fetch(`${appConfig.api.url}user/delete-card`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getRefferals() {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors"
  };

  return fetch(`${appConfig.api.url}user/view-referrals`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}




// WEBPACK FOOTER //
// ./src/app/services/API/frontService.js